<template>
  <div id="AssetView">
    <div :class="`loader${loaderClass}`" v-show="loading"></div>
    <div id="page-content-wrapper" class="admin-content-area">
      <template v-if="cantAccessPage === true">
        <div class="page-name">
          <div class="page-title"> Customer Credit Details </div>
          <!-- Button for Clear Cache -->
          <clear-cache-data :pageKey="[pageKey]"></clear-cache-data>
          <div class="btn-groups text-right">
            <router-link v-if="canEditCredit == true" class="btn btn-primary"
              v-bind:to="{ name: 'CustomerCreditInformationUpdate', params: { id: creditId }, query: { customerflag: 'update' } }">
              <i class="fp-edit-icon"></i> Edit
            </router-link>
            <router-link v-if="canViewCredit == true" class="btn btn-secondary"
              v-bind:to="{ name: 'CreditApplicationList' }"> <i class="fp-back"></i> Back</router-link>
          </div>
        </div>
        <div class="container-fluid">
          <div class="admin-page-content customer-credit-detail list-view">
            <section class="internal-container">
              <div id="tabs" class="containerTab mt-3">
                <div class="tabs">
                  <a v-on:click="activetab = 1" v-bind:class="[activetab === 1 ? 'active' : '']">Customer Credit
                    Details</a>
                  <a v-on:click="activityLogs()" v-bind:class="[activetab === 2 ? 'active' : '']">Activity Log</a>
                </div>
                <div class="content">
                  <div v-show="activetab === 1" class="tabcontent">
                    <div class="list-sections">
                      <div class="form-row no-divider">
                        <div class="col-md-6">
                          <div class="row form-group">
                            <label class="col">Company Name :</label>
                            <span class="col">{{ titleCase(creditData.company_name) }}</span>
                          </div>
                          <div class="row form-group">
                            <label class="col">Credit Limit :</label>
                            <span class="col">{{ titleCase(creditData.credit_limit) }}</span>
                          </div>
                          <div class="row form-group">
                            <label class="col">Contact Name :</label>
                            <span class="col">{{ titleCase(creditData.credit_contact) }}</span>
                          </div>
                          <div class="row form-group">
                            <label class="col">Application For :</label>
                            <span class="col">
                              <template v-for="(app, key) in application_for">
                                <a :key="key" v-if="app && key != 0">&nbsp;&nbsp;|</a>&nbsp;<span :key="'i' + key">{{
                                    titleCase(app)
                                }}</span>
                              </template>
                            </span>
                          </div>
                          <div class="row form-group">
                            <label class="col">Customer Number :</label>
                            <span class="col">{{ titleCase(creditData.customer_number) }}</span>
                          </div>

                          <div class="row form-group">
                            <label class="col">Phone Number :</label>
                            <span class="col">{{ titleCase(creditData.phone) }}</span>
                          </div>
                          <div class="row form-group">
                            <label class="col">Sic Code :</label>
                            <span class="col">{{ creditData.c_business_code }}
                              |{{ titleCase(creditData.c_business_type) }}</span>
                          </div>

                          <div class="row form-group">
                            <label class="col">Partnership :</label>
                            <span class="col">{{ titleCase(creditData.partnership) }}</span>
                          </div>

                          <div class="row form-group">
                            <label class="col">City :</label>
                            <span class="col">{{ titleCase(creditData.city) }}</span>
                          </div>
                          <div class="row form-group">
                            <label class="col">State :</label>
                            <span class="col">{{ titleCase(creditData.state) }}</span>
                          </div>

                          <div class="row form-group">
                            <label class="col">Zip :</label>
                            <span class="col">{{ titleCase(creditData.zip) }}</span>
                          </div>
                          <div class="row form-group">
                            <label class="col">Application For :</label>
                            <span class="col">
                              <template v-for="(app, key) in application_for">
                                <span :key="'i' + key">{{ titleCase(app) }}
                                  <template><span
                                      v-if="key + 1 < application_for.length">&nbsp;|&nbsp;</span></template>
                                </span>
                              </template>
                            </span>
                          </div>

                          <div class="row form-group">
                            <label class="col">Title :</label>
                            <span class="col">{{ titleCase(creditData.title) }}</span>
                          </div>
                          <div class="row form-group">
                            <label class="col">EIN :</label>
                            <span class="col">{{ titleCase(creditData.federal_tx_id) }}</span>
                          </div>
                          <div class="row form-group">
                            <label class="col">Current Business With :</label>
                            <span class="col">{{ titleCase(creditData.which_company) }}</span>
                          </div>

                          <div class="row form-group">
                            <label class="col">Ansonia Risk Score :</label>
                            <span class="col">{{ titleCase(creditData.ansonia_risk_store) }}</span>
                          </div>

                          <!-- <div class="row form-group">
                                <label class="col">Ansonia DTP :</label>
                                <span class="col" >{{titleCase(creditData.ansonia_dtp)}}</span>
                              </div> 

                              <div class="row form-group">
                                <label class="col">Ansonia High Balance :</label>
                                <span class="col" >{{titleCase(creditData.ansonia_high_balance)}}</span>
                              </div> -->
                          <div class="row form-group">
                            <label class="col">Business Start Date :</label>
                            <span class="col">{{ titleCase(creditData.years_in_business) }}</span>
                          </div>

                          <div class="row form-group">
                            <label class="col">DNB Paydex Score :</label>
                            <span class="col">{{ titleCase(creditData.dnb_paydex_score) }}</span>
                          </div>

                          <div class="row form-group">
                            <label class="col">Paynet Master Score :</label>
                            <span class="col">{{ titleCase(creditData.paynet_master_score) }}</span>
                          </div>

                          <div class="row form-group">
                            <label class="col">Credit Grade :</label>
                            <span class="col">{{ titleCase(creditData.credit_grade) }}</span>
                          </div>
                          <div class="row form-group">
                            <label class="col">Full KIN Score :</label>
                            <span class="col">{{ titleCase(creditData.full_kin_score) }}</span>
                          </div>

                          <div class="row form-group">
                            <label class="col">Last Credit Review :</label>
                            <span class="col">{{ titleCase(creditData.last_credit_review) }}</span>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="row form-group">
                            <label class="col">Signature :</label>
                            <span class="col">
                              <template v-if="creditData.signature">
                                <img :src="creditData.signature" alt="NA" height="90" />
                              </template>
                              <template v-else>
                                NA
                              </template>
                            </span>
                          </div>
                          <div class="row form-group">
                            <label class="col">Signature :</label>
                            <span class="col">
                              <template v-if="creditData.signature1">
                                <img :src="creditData.signature1" alt="NA" height="90" />
                              </template>
                              <template v-else>
                                NA
                              </template>
                            </span>
                          </div>
                          <div class="row form-group">
                            <label class="col">Resale Document :</label>
                            <span class="col">
                              <template v-for="(doc, vkey) in creditData.resale_doc_path">
                                <span :key="'a' + vkey">
                                  <a href="javascript:void(0)" class="resale-document"
                                    v-on:click="downloadDoc(doc.url)">
                                    <img v-if="doc.url" style="" :src="doc.url" :alt="doc.display_name" />
                                  </a>
                                  <span v-if="!doc.url" :key="'b' + vkey">NA</span>
                                </span><br />
                              </template>
                            </span>
                          </div>
                          <div class="row form-group">
                            <label class="col">Verification Document :</label>
                            <span class="col">
                              <template v-for="(doc, vkey) in creditData.verification_doc">
                                <span :key="'c' + vkey">
                                  <a href="javascript:void(0)" v-on:click="downloadDoc(doc.url)">
                                    <span style="color:blue; cursor: pointer;">{{ doc.display_name }}</span>
                                  </a>
                                  <template
                                    v-if="creditData.verification_doc.length > 1 && vkey + 1 < creditData.verification_doc.length">
                                    <span :key="'e' + vkey"> | </span></template>
                                  <span v-if="!doc.url" :key="'d' + vkey">NA</span></span>
                              </template>
                            </span>
                          </div>
                          <div class="row form-group">
                            <label class="col">Tax Exemption: </label>
                            <span class="col" v-if="creditData.tax_exemption == 1">Yes</span>
                            <span class="col" v-else>No</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="list-sections" v-if="verifiedData.name">
                      <hr class="light-hr" />
                      <h5> VVG Financial Verified </h5>
                      <div class="form-row no-divider">
                        <div class="col-md-6">
                          <div class="row form-group">
                            <label class="col">Company Name :</label>
                            <span class="col">{{ titleCase(verifiedData.name) }}</span>
                          </div>
                          <div class="row form-group">
                            <label class="col">Address :</label>
                            <span class="col">{{ titleCase(verifiedData.address) }}</span>
                          </div>
                          <div class="row form-group">
                            <label class="col">City :</label>
                            <span class="col">{{ titleCase(verifiedData.city) }}</span>
                          </div>
                          <div class="row form-group">
                            <label class="col">State :</label>
                            <span class="col">{{ titleCase(verifiedData.state) }}</span>
                          </div>
                          <div class="row form-group">
                            <label class="col">Zip :</label>
                            <span class="col">{{ titleCase(verifiedData.zip) }}</span>
                          </div>
                          <div class="row form-group">
                            <label class="col">Phone :</label>
                            <span class="col">{{ titleCase(verifiedData.phone) }}</span>
                          </div>
                          <div class="row form-group">
                            <label class="col">Email :</label>
                            <span class="col">{{ verifiedData.email }}</span>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="row form-group">
                            <label class="col">Credit Limit :</label>
                            <span class="col">{{ titleCase(verifiedData.credit_limit) }}</span>
                          </div>
                          <div class="row form-group">
                            <label class="col">Contact :</label>
                            <span class="col">{{ titleCase(verifiedData.contact) }}</span>
                          </div>
                          <div class="row form-group">
                            <label class="col">Average Payment Days :</label>
                            <span class="col">{{ verifiedData.avg_pay_days }}</span>
                          </div>
                          <div class="row form-group">
                            <label class="col">Last Payment Date :</label>
                            <span class="col">{{ titleCase(verifiedData.payment_date) }}</span>
                          </div>
                          <div class="row form-group">
                            <label class="col">Current Open Balance :</label>
                            <span class="col">{{ verifiedData.open_balance }}</span>
                          </div>
                          <div class="row form-group">
                            <label class="col">Term Id :</label>
                            <span class="col">{{ verifiedData.term_id }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-show="activetab === 2" class="tabcontent" id="customer-activity-logs">
                    <credit-activity-log-list :activityLogVal="activityLogsTabValue"></credit-activity-log-list>
                  </div>
                </div>

              </div>
            </section>
          </div>
        </div>
      </template>
      <template v-else-if="cantAccessPage === false">
        <div class="col-md-12">
          <div class="error-template">
            <h1>Oops!</h1>
            <h2>403</h2>
            <div class="error-details">Sorry!, You don't have permission to access this page.</div>
          </div>
        </div>
      </template>
      <template v-else>
        <loading-content></loading-content>
      </template>
      <app-footer></app-footer>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { commonMixins } from "../mixins/commonMixins";

import ActivityLogListView from '@/components/ActivityLogList.vue';

Vue.component("credit-activity-log-list", ActivityLogListView);


export default {
  name: "AssetView",
  metaInfo: {
    // title will be injected into parent titleTemplate
    title: "Customer Credit Detail View | " +process.env.COPYRIGHT_NAME
  },
  mixins: [commonMixins],
  data: () => ({
    firstLoad: 0,
    permissions: [],
    cantAccessPage: "",
    loading: false,
    activetab: 1,
    creditData: "",
    application_for: [],
    basePath: "",
    verifiedData: [],
    canEditCredit: false,
    canViewCredit: false,
    creditId: 0,
    activityLogsTabValue: "dontLoadList",
    activityLoaded: false,
    pageKey: "",
  }),
  watch: {
    //check permission change
    permissions: function (permissions) {
      var self = this;
      if (permissions.length > 0) {
        for (var i = 0; i < permissions.length; i++) {
          if (permissions[i].name == "view_credit_application") {
            self.cantAccessPage = true;
          }
          if (permissions[i].name == "add_credit_application") {
            self.canEditCredit = true;
          }
          if (permissions[i].name == "view_credit_application") {
            self.canViewCredit = true;
          }

        }
      }
    }
  },
  created: function () { },
  mounted: function () {

    var self = this;
    var path = window.location.pathname;
    var segments = path.split("/");

    self.creditId = segments[3];
    self.pageKey = '_credit_view_' + self.creditId;
    /* var path =  process.env.ROOT_API;
 
     var imgPath = path.split('/');
     console.log(imgPath);
 
     self.basePath = imgPath[0]+'//'+imgPath[2];*/

    self.loadCreditView();
    self.getPermissions();
    //self.verifyCompany();
  },
  methods: {
    downloadDoc: function (doc) {
      var self = this;
      if (doc == '') {
        self.$swal('', 'No Document availble', 'info');
        return;
      }
      var docPath = doc;
      var save = document.createElement('a');
      save.href = docPath;
      save.download = docPath;
      save.target = '_blank';
      document.body.appendChild(save);
      save.click();
      document.body.removeChild(save);
    },
    handleClick(newTab) {
      var self = this;
      self.currentTab = newTab;
    },

    selectTab(flag) {
      alert("You are select " + flag);
    },

    loadCreditView() {
      var path = window.location.pathname;
      var segments = path.split("/");
      var self = this;

      $.ajax({
        url: process.env.ROOT_API + "/credit_app_view",
        type: "GET",
        headers: this.ajxHeaders,
        data: {
          id: segments[3]
        },
        dataType: "json",
        success: function (data) {
          if (data.status == "success") {
            self.loading = false;
            self.creditData = data.content;
            self.application_for = data.application;
          }
        },
        error: function (jqXHR, exception) {
          self.loading = false;
          setTimeout(function () {
            self.generateStatusCodeMessage(jqXHR, false, 'credit-view-page')
          }, 500);


        }
      });
    },
    verifyCompany() {

      var path = window.location.pathname;
      var segments = path.split("/");
      var self = this;
      $.ajax({
        url: process.env.ROOT_API + "/verify_company",
        type: "POST",
        headers: this.ajxHeaders,
        data: {
          id: segments[3]
        },
        dataType: "json",
        success: function (data) {
          console.log(data);
          if (data.message == "success") {
            if (data.content.length > 0) {
              self.verifiedData = data.content[0];

            }

          }
        },
        error: function (jqXHR, exception) {
          self.loading = false;
          self.generateStatusCodeMessage(jqXHR, true, '')
        }
      });

    },
    titleCase(str) {
      if (str == null) {
        return "-";
      } else {
        var value = str.toString();
        return value.charAt(0).toUpperCase() + value.slice(1);
      }
    },
    activityLogs() {

      var self = this;
      var path = window.location.pathname;
      var segments = path.split("/");

      self.$root.$emit('activity_log_opted', 'credit application', segments[3]);
      self.activityLogsTabValue = "loadList";     // flag value set to loadList so that filters in list work properly.
      self.activetab = 2;
    }

  }
};
</script>



// WEBPACK FOOTER //
// src/components/CreditApplicationView.vue